import * as api from '../../../api';

const fetchProgramListActions = api.fetchActions('program-list', 'fetch-program-list');

export const actionTypes = {
  ...fetchProgramListActions.actionTypes,
  CHANGE_PAGE_NUMBER: 'program-list.change-page-number',
  CHANGE_SORT: 'program-list.change-sort',
  SHOW_FORM_DETAILS: 'program-list.show-form-details',
  INIT_PROGRAM_DATA: 'program-list.init-program-data'
}

function shouldFetchPrograms(state, siteId, formId)
{
  const { programs } = state;
  const programsState = programs.getIn([siteId, formId]);
  const { programListState } = programsState || {};
  return programsState && (!programListState || !(programListState.isFetching || programListState.isValid));
}

export function initProgramData(siteId, formId) {
  return {
    type: actionTypes.INIT_PROGRAM_DATA,
    siteId,
    formId
  }
}

export function fetchProgramList(siteId, formId) {
  return (dispatch, getState) => {
    const state = getState();
    const { programs } = state;
    const programsState = programs.getIn([siteId, formId]);
    if(shouldFetchPrograms(state, siteId, formId)) {
      const { currentPage, itemsPerPage, sortBy, sortAsc } = programsState || {};

      const params = {
        touchpointId: formId,
        page: currentPage,
        perPage: itemsPerPage,
        sortBy,
        sortAsc,
      };

      return dispatch(api.getThunk(`/sites/${siteId}/programs-by-form`, params, fetchProgramListActions, { siteId, formId }));
    }
    else {
      return Promise.resolve(programsState.programListState.programList);
    }
  }
}

export function changePageNumber(siteId, formId, page) {
  return {
    type: actionTypes.CHANGE_PAGE_NUMBER,
    siteId,
    formId,
    page
  }
}

export function changeSort(siteId, formId, newSort) {
  return (dispatch, getState) => {
    const { programs } = getState();
    const programsState = programs.getIn([siteId, formId]);
    const { sortBy, sortAsc } = programsState || {};
    if(sortBy === newSort)
      dispatch(changeSortStart(siteId, formId, newSort, !sortAsc));
    else
      dispatch(changeSortStart(siteId, formId, newSort, true));
  }
}

function changeSortStart(siteId, formId, sortBy, sortAsc) {
  return {
    type: actionTypes.CHANGE_SORT,
    siteId,
    formId,
    sortBy,
    sortAsc
  }
}
